var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37671 12.0962H3.82023C3.21601 12.0962 2.63653 12.3336 2.20927 12.7561C1.78202 13.1787 1.54199 13.7518 1.54199 14.3494V30.1218C1.54199 30.7194 1.78202 31.2925 2.20927 31.7151C2.63653 32.1376 3.21601 32.375 3.82023 32.375H33.4374C34.0416 32.375 34.6211 32.1376 35.0483 31.7151C35.4756 31.2925 35.7156 30.7194 35.7156 30.1218V14.3494C35.7156 13.7518 35.4756 13.1787 35.0483 12.7561C34.6211 12.3336 34.0416 12.0962 33.4374 12.0962H31.1591",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1591 26.742H19.7679H31.1591Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1591 21.109H24.3244H31.1591Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1591 26.742H19.7679M31.1591 21.109H24.3244M8.37671 12.0962H3.82023C3.21601 12.0962 2.63653 12.3336 2.20927 12.7561C1.78202 13.1787 1.54199 13.7518 1.54199 14.3494V30.1218C1.54199 30.7194 1.78202 31.2925 2.20927 31.7151C2.63653 32.1376 3.21601 32.375 3.82023 32.375H33.4374C34.0416 32.375 34.6211 32.1376 35.0483 31.7151C35.4756 31.2925 35.7156 30.7194 35.7156 30.1218V14.3494C35.7156 13.7518 35.4756 13.1787 35.0483 12.7561C34.6211 12.3336 34.0416 12.0962 33.4374 12.0962H31.1591H8.37671Z",
    stroke: "#1429B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23828 23.9873L12.8762 23.1911L27.3749 8.85176C27.6922 8.53791 27.9439 8.16532 28.1157 7.75526C28.2874 7.3452 28.3758 6.9057 28.3758 6.46186C28.3758 6.01801 28.2874 5.57851 28.1157 5.16845C27.9439 4.75839 27.6922 4.38581 27.3749 4.07196C27.0576 3.75811 26.6808 3.50916 26.2662 3.33931C25.8516 3.16945 25.4072 3.08203 24.9584 3.08203C24.5097 3.08203 24.0653 3.16945 23.6507 3.33931C23.236 3.50916 22.8593 3.75811 22.542 4.07196L8.04326 18.4113L7.23828 23.9873Z",
    fill: "#CDD3FE",
    stroke: "#1429B8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.7aaa005ce6ca09e948c9b403969fbadd.svg";
export { ForwardRef as ReactComponent };